/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in 
*                 part without express written permission of Honeywell Inc. 
*                 is prohibited.
*
* Name          : order-summary-reducer.ts
* 
* Project Title : Checkout
*  
* Description   : Initial version
* 
* Company       : Honeywell Technology Solutions , Hyderabad
* 
* @Author       : H352615
* 
* @Date         : AUG 2, 2019
*
* @Version      : Version 1.0
*
* By            : H352615
* On            : Aug 13, 2019
* Description   : Updated code as ASDS-997

* By            : Sandeep Raja
* On            : 20 Nov 2019
* Description   : ASDS-1643: Tax Service Exception Scenario
******************************************************************************/

import Reducer from './reducer';
import { AsdsReduxAction } from '../../../../types';
import { createReducer } from '../utils/redux-util';
import ActionConstants from '../action-constants';

class OrderSummaryReducer extends Reducer {

    static getOrderSummaryInitiated(state, _action: AsdsReduxAction) {
        return {
            ...state,
            orderSummary: {
                data: {},
                isFetching: true,
                isSuccess: false,
            },
        };
    }

    static setOrderSummary(state, action: AsdsReduxAction) {
        return {
            ...state,
            orderSummary: {
                data: action.payload.data,
                taxSuccessOrFailure: action.payload.taxSuccessOrFailure,
                isFetching: action.payload.isFetching,
                isSuccess: action.payload.isSuccess,
            },
        };
    }

}

const orderSummaryActionHandlers = {
    [ActionConstants.SET_ORDER_SUMMARY]: OrderSummaryReducer.setOrderSummary,
    [ActionConstants.GET_ORDER_SUMMARY]: OrderSummaryReducer.getOrderSummaryInitiated,
}

const initialState = {
    orderSummary: {
        data: {},
        isFetching: true,
        isSuccess: false,
        taxSuccessOrFailure: false,
    },
};

export const orderSummary = createReducer(initialState, orderSummaryActionHandlers);